
export default "/assets/bolt-micro.694e5510.svg"